import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AppUpdateService } from '../../service/app-update.service';

/**
 * The Update button (30 Oct 2026): shows when a newer Link is out; one tap is a quick hard reload
 * into it, and once Link is up to date the button is gone. Sits next to the logo in the header;
 * `corner` is the sign-in screen's own — the Link icon at the top left, hopping, with a small
 * turning arrow on it; `floating` is the stand-in the app shows at the top of other pages without
 * a header (chat on a phone).
 */
@Component({
  selector: 'app-update-button',
  templateUrl: './update-button.component.html',
  styleUrls: ['./update-button.component.css'],
})
export class UpdateButtonComponent implements OnInit, OnDestroy {
  readonly update = inject(AppUpdateService);
  @Input() floating = false;
  @Input() corner = false;
  private release?: () => void;

  ngOnInit(): void {
    if (!this.floating) this.release = this.update.registerPageButton();
  }

  ngOnDestroy(): void {
    this.release?.();
  }
}
